import React, { useState, useEffect } from 'react';
import { useAuth } from '../../components/web3/context/AuthContext';
import TokensExchange from '../../components/dashboard-controler/tokens-exchange';
import defaultBg from '../../assets/images/all-img/v3/dashboardBg.jpg';
import nftsBg from '../../assets/images/all-img/v3/hero-thumb2.jpg';
import collectionsBg from '../../assets/images/all-img/v3/hero-thumb3.jpg';
import claimTokensBg from '../../assets/images/all-img/v3/hero-thumb4.jpg';
import claimNftsBg from '../../assets/images/all-img/v3/hero-thumb5.jpg';
import createCollection from '../../assets/images/all-img/v3/createCollection.jpg';
import MyNfts from '../nft-gallery/my-nft';
import CollectionManager from '../../components/collections-manager/create-collection/collection-manager';
import ClaimNfts from '../nft-gallery/claim-nft';
import MySchedules from '../schedule-transaction/mySchedules';
import ClaimFund from '../claim-fund/claim-fund';
import ReactGA from 'react-ga4';
import MyCollectionsLibrary from '../../components/collections-manager/my-collections-library';
import CollectionCreationManager from '../../components/collections-manager/create-collection/collection-creation-manager';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import NFTAccessManager from '../../components/nftAccess/nft-access-manager';
const TransferDashboard = () => {
  const IMGS_BG = {
    Tokens: defaultBg,
    NFTs: nftsBg,
    Collections: collectionsBg,
    Claim_Tokens: claimTokensBg,
    Claim_NFTs: claimNftsBg,
    Schedules: defaultBg,
    CreateNewCollection: createCollection,
    NFT_Access: defaultBg,
  };
  const search = useLocation().search;
  const queryParams = new URLSearchParams(search);
  const selectedTab = queryParams.get('selectedTab');
  const { isLoggedIn, loginOption, network, supportedOptions, email, entityInfo, isLoading } = useAuth();
  const { t } = useTranslation();
  const [filterKey, setFilterKey] = React.useState();
  const [activeClass, setActiveClass] = React.useState();
  const [backgroundIm, setBackgroundIm] = useState(defaultBg);
  const handleFilterKeyChange = (key) => {
    setFilterKey(key);
    setActiveClass(key);
    setBackgroundIm(IMGS_BG[key]);
    removeSelectedTab()
  };

  const handleActiveClass = (key) => {
    if (key === activeClass) return 'active';
  };
  useEffect(() => {
    const value = selectedTab;
    if (!value || value == "") return
    handleFilterKeyChange(value);
  }, [selectedTab]);

  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: '/TransferDashboard',
      title: 'Transfer Dashboard Page',
    });
  }, []);

  useEffect(() => {
    const defaultKey = selectedTab ? selectedTab : 'Tokens';
    function updateStatesByKey(key) {
      setFilterKey(key);
      setActiveClass(key);
      setBackgroundIm(IMGS_BG[key]);
    }

    function checkAndUpdateFilter(currentFilter, newSupportedOptions) {
      const optionsMap = {
        Tokens: 'Tokens',
        NFTs: 'NFTs',
        Collections: 'Collections',
        Claim_Tokens: 'Claim_Tokens',
        Claim_NFTs: 'Claim_NFTs',
        Schedules: 'Schedules',
        NFT_Access: 'NFT_Access',
      };

      if (newSupportedOptions[currentFilter]) {
        updateStatesByKey(optionsMap[currentFilter]);
      } else {
        updateStatesByKey(defaultKey);
      }
    }

    if (supportedOptions) {
      checkAndUpdateFilter(filterKey, supportedOptions);
    } else {
      updateStatesByKey(defaultKey);
    }
  }, [supportedOptions]);

  const transparentBackground = {
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${backgroundIm})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
  };
  function removeSelectedTab() {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.delete('selectedTab');
    const newUrl = window.location.pathname + '?' + urlParams.toString();
    window.history.replaceState({}, '', newUrl);
  }
  return (
    <div
      className="fugu--dashboard-section "
      style={{
        backgroundImage: `url(${backgroundIm})`,
        backgroundSize: `${activeClass == 'Claim_NFTs' ? "contain" : "cover"}`,
        backgroundRepeat: `${activeClass == 'Claim_NFTs' ? "initial" : 'no-repeat'}`,
      }}
    >
      {isLoggedIn ? (
        <>
          <div className="fugu--portfolio-menu">
            <ul className="option-set clear-both mx-3 ps-0">
              {supportedOptions?.Tokens && (
                <li
                  onClick={() => handleFilterKeyChange('Tokens')}
                  className={handleActiveClass('Tokens')}
                >
                  <span>{t("dashboard.tabs.tokens.title")}</span>
                </li>
              )}
              {supportedOptions?.NFTs && (
                <li
                  onClick={() => handleFilterKeyChange('NFTs')}
                  className={handleActiveClass('NFTs')}
                >
                  <span>{t("dashboard.tabs.nfts.title")}</span>
                </li>
              )}
              {supportedOptions?.Collections && (
                <li
                  onClick={() => handleFilterKeyChange('Collections')}
                  className={handleActiveClass('Collections')}
                >
                  <span>{t("dashboard.tabs.myCollections.title")}</span>
                </li>
              )}
              {supportedOptions?.Collections && (
                <li
                  onClick={() => handleFilterKeyChange('CreateNewCollection')}
                  className={handleActiveClass('CreateNewCollection')}
                >
                  <span>{t("dashboard.tabs.createCollection.title")}</span>
                </li>
              )}
              {/* //claim tokens feature support social login and evm  wallets only */}
              {(supportedOptions?.Claim_Tokens && loginOption == 'custodial') && (
                <li
                  onClick={() => handleFilterKeyChange('Claim_Tokens')}
                  className={handleActiveClass('Claim_Tokens')}
                >
                  <span>{t("dashboard.tabs.claimTokens.title")}</span>
                </li>
              )}
              {/* //claim nfts feature support social login and evm  wallets only */}
              {(supportedOptions?.Claim_NFTs && loginOption == 'custodial') && (
                <li
                  onClick={() => handleFilterKeyChange('Claim_NFTs')}
                  className={handleActiveClass('Claim_NFTs')}
                >
                  <span>{t("dashboard.tabs.claimNFTs.title")}</span>
                </li>
              )}
              {supportedOptions?.Schedules && (
                <li
                  onClick={() => handleFilterKeyChange('Schedules')}
                  className={handleActiveClass('Schedules')}
                >
                  <span>{t("dashboard.tabs.schedules.title")}</span>
                </li>
              )}
              {supportedOptions?.NFT_Access && (
                <li
                  onClick={() => handleFilterKeyChange('NFT_Access')}
                  className={handleActiveClass('NFT_Access')}
                >
                  <span>{t("dashboard.tabs.nftAccess.nftAccess")}</span>
                </li>
              )}
            </ul>
          </div>
          {activeClass == 'Tokens' ? (
            <TokensExchange />
          ) : activeClass == 'NFTs' ? (
            <MyNfts />
          ) : activeClass == 'Collections' ? (
            <MyCollectionsLibrary />
          ) : activeClass == 'CreateNewCollection' ? (
            <CollectionCreationManager />
          ) : //claim tokens feature support social login and evm  wallets only
            activeClass == 'Claim_Tokens' && loginOption == 'custodial' ? (
              <ClaimFund />
            ) : //claim nfts feature support social login and evm  wallets only
              activeClass == 'Claim_NFTs' && loginOption == 'custodial' ? (
                <ClaimNfts />
              ) : //my schedules supported in custodial "EVM ONLY" and noneCustodial
                activeClass == 'Schedules' ? (
                  <MySchedules />
                ) : //
                  activeClass == 'NFT_Access' ? (
                    <NFTAccessManager />
                  ) : (
                    <></>
                  )}

        </>
      ) : (
        <>
          {/* <Preloader show={isLoading} /> */}
          <div className="d-flex justify-content-center">
            <div className="header-btn">
              <a className="fugu--btn fugu--menu-btn1" href="/">
                {t("general.connectWithSystem")}
              </a>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
export default TransferDashboard;
